<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Sliders Horizontal" class="d-icon d-icon--sliders-horizontal" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><g :clip-path="`url(#${uniqueID}a)`"><path fill-rule="evenodd" clip-rule="evenodd" d="M11 2a.5.5 0 0 0-.5-.5h-3V1a.5.5 0 1 0-1 0v2a.5.5 0 0 0 1 0v-.5h3A.5.5 0 0 0 11 2Zm-9.5-.5a.5.5 0 0 0 0 1H5a.5.5 0 1 0 0-1H1.5Zm4 4.5a.5.5 0 0 1 .5-.5h4.5a.5.5 0 1 1 0 1H6a.5.5 0 0 1-.5-.5Zm-4-.5a.5.5 0 0 0 0 1h2V7a.5.5 0 0 0 1 0V5a.5.5 0 1 0-1 0v.5h-2Zm9 4a.5.5 0 1 1 0 1h-2v.5a.5.5 0 1 1-1 0V9a.5.5 0 0 1 1 0v.5h2Zm-9 0a.5.5 0 1 0 0 1H6a.5.5 0 1 0 0-1H1.5Z" fill="currentColor"/></g><defs><clipPath :id="`${uniqueID}a`"><path fill="#fff" d="M0 0h12v12H0z"/></clipPath></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconSlidersHorizontal',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
